module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.0d248fe.woff";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/dist/src/fonts/Roboto-Regular.woff
// module id = kKWV
// module chunks = 1